var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{attrs:{"right":"","stateless":"","floating":"","fixed":true,"clipped":true,"value":_vm.navigationDrawerOpen,"app":""}},[_c('Toc'),_c('Calendar'),_c('Tasks'),_c('MessageStats'),_c('News')],1)}
var staticRenderFns = []

export { render, staticRenderFns }